/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ listings: NonNullable<unknown>, crm: NonNullable<unknown> }} Pm_Preview_HintInputs */

const cs_pm_preview_hint = /** @type {(inputs: Pm_Preview_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.listings} inzerátů z portálu. Nemovitostí v CRM bez inzerátu: ${i?.crm}. Zkontrolujte nejisté páry, ostatní můžete potvrdit hromadně.`)
};

const en_pm_preview_hint = /** @type {(inputs: Pm_Preview_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.listings} portal listings. CRM properties without a listing: ${i?.crm}. Review the unsure pairs; confirm the rest in bulk.`)
};

/**
* | output |
* | --- |
* | "{listings} portal listings. CRM properties without a listing: {crm}. Review the unsure pairs; confirm the rest in bulk." |
*
* @param {Pm_Preview_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_preview_hint = /** @type {((inputs: Pm_Preview_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Preview_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_preview_hint(inputs)
	return cs_pm_preview_hint(inputs)
});